export default __webpack_public_path__ + "static/media/project.12d462e7.svg";